









































import Vue from "vue";
import { VUEX_ROOT_ACTION_NAMES } from "@tt-app/constants";

import IconClose from "@joyz/app-core/assets/icons/white/Close.svg";
import { NotificationPermission } from "@tt-app/store/user/types";

const { ONE_SIGNAL_RECORD_CTA_INTERACTION } = VUEX_ROOT_ACTION_NAMES;

interface Data {
  icons: {
    [name: string]: string;
  };
}

interface Methods {
  handleCallToActionPromptClick: () => void;
  handleCallToActionGrantClick: () => void;
  handleCallToActionDenyClick: () => void;
}

interface Computed {
  ctaInteraction: string;
  notificationPermissions: string;
  permissionsAlreadyDecided: boolean;
  permissionsAlreadyGranted: boolean;
}

export default Vue.extend<Data, Methods, Computed, never>({
  name: "CallToAction",

  data() {
    return {
      icons: {
        close: IconClose
      }
    };
  },

  methods: {
    handleCallToActionPromptClick() {
      this.$store.dispatch(ONE_SIGNAL_RECORD_CTA_INTERACTION);
    },

    handleCallToActionGrantClick() {
      this.$store.dispatch(ONE_SIGNAL_RECORD_CTA_INTERACTION, NotificationPermission.GRANTED);
    },

    handleCallToActionDenyClick() {
      this.$store.dispatch(ONE_SIGNAL_RECORD_CTA_INTERACTION, NotificationPermission.DENIED);
    }
  },

  computed: {
    ctaInteraction() {
      return this.$store.state.oneSignal.ctaInteraction;
    },

    notificationPermissions() {
      return this.$store.state.oneSignal.notificationPermission;
    },

    permissionsAlreadyDecided() {
      return this.notificationPermissions !== NotificationPermission.DEFAULT;
    },

    permissionsAlreadyGranted() {
      return this.notificationPermissions === NotificationPermission.GRANTED;
    }
  }
});
